import React from 'react';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { ArrowUpFromLine, Package, Truck, CheckCircle, Clock, MapPin, FileText, User } from 'lucide-react';
export function WarehouseOutbound() {
  const outboundOrders = [{
    id: 'OUT-001',
    poNumber: 'PO-2023-001',
    cooperative: 'Koperasi Maju Jaya',
    destination: 'Bogor, Jawa Barat',
    address: 'Jl. Raya Desa No. 123, RT 01/RW 02',
    products: [{
      name: 'Indomie Goreng Special',
      quantity: 20,
      unit: 'Karton'
    }, {
      name: 'Aqua Galon 19L',
      quantity: 12,
      unit: 'Galon'
    }],
    totalItems: 32,
    status: 'ready',
    statusLabel: 'Siap Kirim',
    deliveryType: 'delivery',
    courier: 'JNE',
    pickupTime: 'Hari ini, 15:00',
    contactPerson: 'Budi Santoso',
    contactPhone: '+62 812-3456-7890'
  }, {
    id: 'OUT-002',
    poNumber: 'PO-2023-003',
    cooperative: 'Koperasi Sejahtera',
    destination: 'Bandung, Jawa Barat',
    address: 'Jl. Soekarno Hatta No. 456',
    products: [{
      name: 'Beras Ramos 5kg',
      quantity: 45,
      unit: 'Karung'
    }],
    totalItems: 45,
    status: 'pickup',
    statusLabel: 'Pickup - Menunggu',
    deliveryType: 'pickup',
    courier: 'Self Pickup',
    pickupTime: 'Besok, 09:00',
    contactPerson: 'Siti Nurhaliza',
    contactPhone: '+62 813-7777-6666'
  }, {
    id: 'OUT-003',
    poNumber: 'PO-2023-006',
    cooperative: 'Koperasi Makmur',
    destination: 'Depok, Jawa Barat',
    address: 'Jl. Margonda Raya No. 789',
    products: [{
      name: 'Indomie Soto',
      quantity: 28,
      unit: 'Karton'
    }],
    totalItems: 28,
    status: 'preparing',
    statusLabel: 'Sedang Disiapkan',
    deliveryType: 'delivery',
    courier: 'J&T',
    pickupTime: 'Besok, 14:00',
    contactPerson: 'Ahmad Yani',
    contactPhone: '+62 814-8888-5555'
  }, {
    id: 'OUT-004',
    poNumber: 'PO-2023-002',
    cooperative: 'Koperasi Mandiri',
    destination: 'Jakarta Selatan',
    address: 'Jl. TB Simatupang No. 321',
    products: [{
      name: 'Aqua Galon 19L',
      quantity: 18,
      unit: 'Galon'
    }],
    totalItems: 18,
    status: 'shipped',
    statusLabel: 'Sudah Dikirim',
    deliveryType: 'delivery',
    courier: 'JNE',
    pickupTime: 'Kemarin, 10:00',
    contactPerson: 'Joko Widodo',
    contactPhone: '+62 815-9999-4444'
  }];
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'ready':
        return 'success';
      case 'pickup':
        return 'warning';
      case 'preparing':
        return 'neutral';
      case 'shipped':
        return 'success';
      default:
        return 'neutral';
    }
  };
  return <div className="space-y-6" data-id="element-3842">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-3843">
        <div data-id="element-3844">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-3845">
            Outbound Management
          </h2>
          <p className="text-sm text-slate-500 mt-1" data-id="element-3846">
            Kelola barang keluar ke koperasi
          </p>
        </div>
        <Button variant="primary" size="sm" icon={<ArrowUpFromLine className="w-4 h-4" data-id="element-3848" />} data-id="element-3847">
          Create Outbound
        </Button>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-4 gap-4" data-id="element-3849">
        <Card className="p-4 bg-blue-50 border-blue-200" data-id="element-3850">
          <div className="flex items-center justify-between" data-id="element-3851">
            <div data-id="element-3852">
              <p className="text-xs text-blue-700 mb-1" data-id="element-3853">Total Outbound</p>
              <p className="text-2xl font-bold text-blue-900" data-id="element-3854">4</p>
            </div>
            <ArrowUpFromLine className="w-8 h-8 text-blue-600" data-id="element-3855" />
          </div>
        </Card>

        <Card className="p-4 bg-green-50 border-green-200" data-id="element-3856">
          <div className="flex items-center justify-between" data-id="element-3857">
            <div data-id="element-3858">
              <p className="text-xs text-green-700 mb-1" data-id="element-3859">Ready to Ship</p>
              <p className="text-2xl font-bold text-green-900" data-id="element-3860">1</p>
            </div>
            <CheckCircle className="w-8 h-8 text-green-600" data-id="element-3861" />
          </div>
        </Card>

        <Card className="p-4 bg-amber-50 border-amber-200" data-id="element-3862">
          <div className="flex items-center justify-between" data-id="element-3863">
            <div data-id="element-3864">
              <p className="text-xs text-amber-700 mb-1" data-id="element-3865">Pickup Pending</p>
              <p className="text-2xl font-bold text-amber-900" data-id="element-3866">1</p>
            </div>
            <User className="w-8 h-8 text-amber-600" data-id="element-3867" />
          </div>
        </Card>

        <Card className="p-4 bg-slate-50 border-slate-200" data-id="element-3868">
          <div className="flex items-center justify-between" data-id="element-3869">
            <div data-id="element-3870">
              <p className="text-xs text-slate-700 mb-1" data-id="element-3871">Preparing</p>
              <p className="text-2xl font-bold text-slate-900" data-id="element-3872">1</p>
            </div>
            <Clock className="w-8 h-8 text-slate-600" data-id="element-3873" />
          </div>
        </Card>
      </div>

      {/* Outbound List */}
      <div className="space-y-4" data-id="element-3874">
        {outboundOrders.map(order => <Card key={order.id} className="p-6" data-id="element-3875">
            <div className="flex items-start gap-6" data-id="element-3876">
              {/* Status Icon */}
              <div className="flex-shrink-0" data-id="element-3877">
                <div className={`w-16 h-16 rounded-xl flex items-center justify-center shadow-lg ${order.status === 'ready' ? 'bg-gradient-to-br from-green-500 to-green-600' : order.status === 'pickup' ? 'bg-gradient-to-br from-amber-500 to-amber-600' : order.status === 'preparing' ? 'bg-gradient-to-br from-slate-400 to-slate-500' : 'bg-gradient-to-br from-blue-500 to-blue-600'}`} data-id="element-3878">
                  {order.status === 'shipped' ? <Truck className="w-8 h-8 text-white" data-id="element-3879" /> : order.status === 'ready' ? <CheckCircle className="w-8 h-8 text-white" data-id="element-3880" /> : order.status === 'pickup' ? <User className="w-8 h-8 text-white" data-id="element-3881" /> : <Package className="w-8 h-8 text-white" data-id="element-3882" />}
                </div>
              </div>

              {/* Order Info */}
              <div className="flex-1 min-w-0" data-id="element-3883">
                <div className="flex items-start justify-between mb-3" data-id="element-3884">
                  <div data-id="element-3885">
                    <div className="flex items-center gap-3 mb-2" data-id="element-3886">
                      <h3 className="text-xl font-bold text-slate-900" data-id="element-3887">
                        {order.poNumber}
                      </h3>
                      <Badge variant={getStatusColor(order.status)} data-id="element-3888">
                        {order.statusLabel}
                      </Badge>
                      <Badge variant={order.deliveryType === 'delivery' ? 'neutral' : 'warning'} data-id="element-3889">
                        {order.deliveryType === 'delivery' ? 'Delivery' : 'Pickup'}
                      </Badge>
                    </div>
                    <div className="flex items-center gap-4 text-sm text-slate-600" data-id="element-3890">
                      <span data-id="element-3891">ID: {order.id}</span>
                      <span className="text-slate-400" data-id="element-3892">•</span>
                      <span data-id="element-3893">To: {order.cooperative}</span>
                    </div>
                  </div>
                  <div className="text-right" data-id="element-3894">
                    <p className="text-sm text-slate-600 mb-1" data-id="element-3895">Total Items</p>
                    <p className="text-2xl font-bold text-cyan-600" data-id="element-3896">
                      {order.totalItems}
                    </p>
                  </div>
                </div>

                {/* Products */}
                <div className="mb-4 p-4 bg-slate-50 rounded-lg border border-slate-200" data-id="element-3897">
                  <p className="text-xs font-bold text-slate-700 mb-2" data-id="element-3898">
                    Products:
                  </p>
                  <div className="space-y-1" data-id="element-3899">
                    {order.products.map((product, i) => <div key={i} className="flex items-center justify-between text-sm" data-id="element-3900">
                        <span className="text-slate-900" data-id="element-3901">{product.name}</span>
                        <span className="font-medium text-slate-600" data-id="element-3902">
                          {product.quantity} {product.unit}
                        </span>
                      </div>)}
                  </div>
                </div>

                {/* Details */}
                <div className="grid grid-cols-4 gap-4 mb-4" data-id="element-3903">
                  <div className="p-3 bg-slate-50 rounded-lg" data-id="element-3904">
                    <p className="text-xs text-slate-600 mb-1" data-id="element-3905">Destination</p>
                    <p className="text-sm font-bold text-slate-900" data-id="element-3906">
                      {order.destination}
                    </p>
                  </div>
                  <div className="p-3 bg-slate-50 rounded-lg" data-id="element-3907">
                    <p className="text-xs text-slate-600 mb-1" data-id="element-3908">Courier</p>
                    <p className="text-sm font-bold text-slate-900" data-id="element-3909">
                      {order.courier}
                    </p>
                  </div>
                  <div className="p-3 bg-slate-50 rounded-lg" data-id="element-3910">
                    <p className="text-xs text-slate-600 mb-1" data-id="element-3911">Pickup Time</p>
                    <p className="text-sm font-bold text-slate-900" data-id="element-3912">
                      {order.pickupTime}
                    </p>
                  </div>
                  <div className="p-3 bg-slate-50 rounded-lg" data-id="element-3913">
                    <p className="text-xs text-slate-600 mb-1" data-id="element-3914">Contact</p>
                    <p className="text-sm font-bold text-slate-900" data-id="element-3915">
                      {order.contactPerson}
                    </p>
                  </div>
                </div>

                {/* Address */}
                <div className="p-3 bg-blue-50 rounded-lg border border-blue-200 mb-4" data-id="element-3916">
                  <div className="flex items-start gap-2" data-id="element-3917">
                    <MapPin className="w-4 h-4 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-3918" />
                    <div data-id="element-3919">
                      <p className="text-xs text-blue-700 mb-1" data-id="element-3920">
                        Shipping Address
                      </p>
                      <p className="text-sm text-blue-900" data-id="element-3921">{order.address}</p>
                      <p className="text-xs text-blue-600 mt-1" data-id="element-3922">
                        {order.contactPhone}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Actions */}
                <div className="flex gap-2 pt-4 border-t border-slate-200" data-id="element-3923">
                  {order.status === 'ready' && <>
                      <Button variant="primary" size="sm" icon={<Truck className="w-4 h-4" data-id="element-3925" />} data-id="element-3924">
                        Handover to Courier
                      </Button>
                      <Button variant="outline" size="sm" icon={<FileText className="w-4 h-4" data-id="element-3927" />} data-id="element-3926">
                        Print Shipping Label
                      </Button>
                    </>}
                  {order.status === 'pickup' && <Button variant="primary" size="sm" icon={<CheckCircle className="w-4 h-4" data-id="element-3929" />} data-id="element-3928">
                      Confirm Pickup
                    </Button>}
                  {order.status === 'preparing' && <Button variant="primary" size="sm" data-id="element-3930">
                      Mark as Ready
                    </Button>}
                  <Button variant="outline" size="sm" data-id="element-3931">
                    View Details
                  </Button>
                </div>
              </div>
            </div>
          </Card>)}
      </div>
    </div>;
}